// extracted by mini-css-extract-plugin
export default {"notifierContainer":"ErrorNotifier_notifierContainer__qMr30"};